import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import React, { useState } from "react";
import { ControlLabel } from "react-bootstrap";
import { setAuthenticatedUser } from "../../../shared/actions";
import { defaultMessages } from "../../../libs/i18n/default";
import { updateOnboardingEmail } from "../../lou/auth";

const FirebaseEmailVerificationUpdate = ({ intl: { formatMessage }, setUpdating, subject }) => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(state => state.authenticatedUser);
  const [email, setEmail] = useState(authenticatedUser.email);
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = async e => {
    e.preventDefault();

    setError(null);
    setSubmitting(true);

    const data = await updateOnboardingEmail(authenticatedUser.id, email, password, subject);

    if (data.success) {
      dispatch(setAuthenticatedUser(data.authenticated_user));
      setSuccess(true);

      setTimeout(() => {
        setUpdating(false);
        setSubmitting(false);
      }, 4000);
    } else {
      if (process.env.NODE_ENV === "development") {
        console.error("[FirebaseEmailVerificationUpdate Failure]", data);
      }
      setError(data.message || "An unexpected error occurred.");
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="text-center">
        <h4><strong>Update your email address</strong></h4>
      </div>
      {error && (
        <div className="alert alert-danger">
          {error}
        </div>
      )}
      {success && (
        <div className="alert alert-success">
          {formatMessage(defaultMessages.clientFirebaseEmailVerificationUpdateSuccess)}
        </div>
      )}
      {!success && (
        <form onSubmit={onSubmit}>
          <ControlLabel>{formatMessage(defaultMessages.clientCommonEmail)}</ControlLabel>
          <input
            className="form-control"
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            style={{ marginBottom: 20 }}
            required
          />
          <ControlLabel>{formatMessage(defaultMessages.clientCommonConfirmPassword)}</ControlLabel>
          <div className="input-group" style={{ marginBottom: "15px" }}>
            <input
              className="form-control"
              type={showPassword ? "text" : "password"}
              value={password}
              placeholder={formatMessage(defaultMessages.clientFirebaseEmailVerificationPlaceholdersPasswordEnter)}
              onChange={e => setPassword(e.target.value)}
              required
            />
            <span
              className="input-group-addon"
              onClick={() => setShowPassword(!showPassword)}
              style={{ cursor: "pointer" }}
            >
              <i className={`fa fa-eye${showPassword ? "-slash" : ""}`} />
            </span>
          </div>
          {password && email === authenticatedUser.email && (
            <div className="text-center mb-2">
              <p style={{ color: "red" }}>Please change your email address to be able to update</p>
            </div>
          )}
          <div className="text-center" style={{ marginTop: 20 }}>
            <button
              type="submit"
              className="btn btn-info"
              style={{ marginRight: 10, borderRadius: 20, padding: "8px 30px" }}
              disabled={!email || !password || submitting || email === authenticatedUser.email}
            >
              {submitting ? <i className="fa fa-spinner fa-spin" style={{ marginRight: 5 }} /> : null}
              Update
            </button>
            <button
              className="btn btn-warning"
              type="button"
              style={{ borderRadius: 20, padding: "8px 30px" }}
              onClick={() => setUpdating(false)}
              disabled={submitting}
            >
              Cancel
            </button>
          </div>
        </form>
      )}
    </>
  );
};

FirebaseEmailVerificationUpdate.propTypes = {
  intl: PropTypes.object,
  setUpdating: PropTypes.func,
  subject: PropTypes.string
};

export default FirebaseEmailVerificationUpdate;
